import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.jpg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiFillMail
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              👋 <b className="purple"> About Me</b> <br />

              I’m a <b className="purple">Senior Software Engineer</b> with 20+ years of experience turning complex ideas into scalable, high-performance products. <br />
              My work spans <b className="purple">Full Stack Development</b>, <b className="purple">AI/LLM solutions</b>, and <b className="purple">Blockchain/Web3 systems</b>, always built with reliability, efficiency, and user experience in mind.
              <br />
              <br />
              💡 <b className="purple"> What I Do</b> <br />

              <b className="purple">Full Stack Development</b> → I build fast, responsive web applications using React, Angular, Node.js, Django, and FastAPI, backed by solid database design and CI/CD automation. <br />

              <b className="purple">AI & LLM Engineering</b> → I integrate AI and large language models (OpenAI, Anthropic, LangChain) into modern systems — from intelligent assistants to automated data-driven tools. <br />

              <b className="purple">Blockchain & Web3</b> → I design and deploy smart contracts, dApps, and DeFi protocols on Ethereum and Solana, ensuring security, scalability, and interoperability. <br />
              
              <b className="purple">Cloud & DevOps</b> → I architect secure, scalable infrastructure across AWS, Azure, and GCP, implementing Docker, Kubernetes, and CI/CD pipelines for continuous delivery. <br />
              <br />

              🚀 <b className="purple"> Why Work With Me</b> <br />

              <b className="purple">Deep </b> Technical Expertise across modern frameworks, cloud, and decentralized technologies <br />  
              <b className="purple">Proven</b> Experience building production systems for global enterprises and fast-scaling startups <br />
              <b className="purple">Commitment</b> to Quality — clean code, strong architecture, and reliable performance in every build <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/DragonWarrior812"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:borrazc00828@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
             
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
